import { toast } from "sonner";
import { savePageLayoutDraft } from "./savePageLayoutDraft";

export const LAYOUT_MODIFIED_TOAST_ID = "page-layout-modified";

let toastDismissedByUser = false;

export const notifyLayoutModifiedToast = (): void => {
  toastDismissedByUser = false;
  showLayoutModifiedToast();
};

export const dismissLayoutModifiedToastByUser = (): void => {
  toastDismissedByUser = true;
  toast.dismiss(LAYOUT_MODIFIED_TOAST_ID);
};

export const clearLayoutModifiedToast = (): void => {
  toastDismissedByUser = false;
  toast.dismiss(LAYOUT_MODIFIED_TOAST_ID);
};

export const isLayoutModifiedToastDismissed = (): boolean =>
  toastDismissedByUser;

export const showLayoutModifiedToast = (): void => {
  if (toastDismissedByUser) {
    return;
  }

  toast.custom(
    (toastId) => (
      <div className="flex items-center gap-3 rounded-lg border border-border bg-background px-4 py-3 shadow-lg">
        <span className="text-sm font-medium text-foreground">
          Page Layout Modified
        </span>
        <button
          type="button"
          className="inline-flex items-center rounded-md bg-primary px-2.5 py-1 text-xs font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          onClick={() => {
            void savePageLayoutDraft();
          }}
        >
          Save
        </button>
        <button
          type="button"
          aria-label="Dismiss"
          className="inline-flex h-6 w-6 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          onClick={() => {
            dismissLayoutModifiedToastByUser();
            toast.dismiss(toastId);
          }}
        >
          ×
        </button>
      </div>
    ),
    {
      id: LAYOUT_MODIFIED_TOAST_ID,
      duration: Infinity,
      dismissible: false,
    },
  );
};
